<template>
  <div class="page_error">
    <div>
      <v-icon class="error_icon">cloud_off</v-icon>
    </div>
    <div class="error_text">
      <h1>502</h1>
      <h3>Bad gateway</h3>
      <p>O servidor encontrou um erro temporário e não pôde concluir sua solicitação.</p>
    </div>
  </div>
</template>
<script>
export default {
    
}
</script>

<style lang="scss" scoped>

</style>
